import axios, { type AxiosRequestConfig, type AxiosResponse } from "axios"

const instance = axios.create({
    responseType: "json",
    timeout: 50000,
})

// 请求拦截
instance.interceptors.request.use((config) => {
    if (!config.baseURL) {
        config.baseURL = useRuntimeConfig().public.api
    }
    return config
})

// 响应拦截
instance.interceptors.response.use(
    (response: AxiosResponse<LyRequest.Response<any>>): any => {
        const { errcode } = response.data
        if (errcode === 0) {
            return Promise.resolve(response.data)
        } else {
            if (errcode > 11000) {
                useNuxtApp().$site.token.value = null
                throw createError({
                    statusCode: 401,
                    statusMessage: "",
                })
            }
            return Promise.reject(response)
        }
    },
    (error) => {
        return Promise.reject(error)
    },
)

export const useBaseAxios = () => {
    return instance
}

export const useBaseGet = <T = any>(
    url: string,
    params?: Record<string, any>,
    config?: Exclude<AxiosRequestConfig, "params">,
) => {
    return instance.get<T, LyRequest.Response<T>>(url, {
        params,
        ...config,
    })
}

export const useBasePost = <T = any>(
    url: string,
    data?: Record<string, any>,
    params?: Record<string, any>,
    config?: Exclude<AxiosRequestConfig, "params">,
) => {
    return instance.post<T, LyRequest.Response<T>>(url, data, {
        params,
        ...config,
    })
}

export const useBaseDelete = <T = any>(
    url: string,
    data?: Record<string, any>,
    params?: Record<string, any>,
    config?: Exclude<AxiosRequestConfig, "params" | "data">,
) => {
    return instance.delete<T, LyRequest.Response<T>>(url, {
        params,
        data,
        ...config,
    })
}
